import React, { Component } from 'react';
import YouTube from 'react-youtube';
import './components/YouTubeEmbed.css';

import cookie from 'react-cookies';

import Input from './components/Input';
import Button from './components/Button';
import Notification from './components/Notification';

import { API_BASE } from './config';
import { Link } from 'react-router';

import RSSlogo from './images/RSS_logo-dark.svg';
import signupMobile from './images/signupMobile.png';

class Authentication extends Component {

  constructor(props) {
    super(props);
    
    this._addUser = this._addUser.bind(this);
    this._signIn = this._signIn.bind(this);
    this._keyboardListen_enter = this._keyboardListen_enter.bind(this);
    this._forgotPassword = this._forgotPassword.bind(this);
    this._toggleSignInUp = this._toggleSignInUp.bind(this);
    this._toggleSignInWithPassword = this._toggleSignInWithPassword.bind(this);
    this._updateSingle = this._updateSingle.bind(this);

    this.state = {
      user_id:0,
      email:localStorage.getItem('email') ? localStorage.getItem('email') : "",
      form:{
        name:"",
        email:localStorage.getItem('email') ? localStorage.getItem('email') : "",
        password:"",
        token:""
      },
      notificationText:"",
      token:this.props.token,
      error:null,

      signInWithPassword:false,

      signup:this.props.referrallink ? true : false
    };

  }

  componentDidMount() {
    if (this.state.token) {
      this._signIn();
    } else {

      // autofocus an input
      if (this.state.signup) {
        this.refs.nameinput.focus();
      } else {
        if (this.state.form.email.length) {
          this.refs.passphraseinput.focus();
        } else {
          this.refs.emailinput.focus();
        }
      }
    }
    //window.addEventListener("focus", this._checkSignIn) // not really necessary

  }

  componentWilUnmount() {
      //window.removeEventListener("focus", this._checkSignIn) // not really necessary
  }

  render() {

      return (
        <div className={this.state.signup ?'App-signIn Page Page-Wide clearfix':'App-signIn Page clearfix'}>
          
          <Notification text={this.state.notificationText} />
          <p style={{maxWidth:"60%",margin:"2em auto"}}><img src={RSSlogo} alt="Really Simple Store" /></p>

          {this.state.signup ? // Sign Up //
            <div>
              
              {this.props.referrallink && this.props.referrallink !== "new" ?
                <div>
                  <p>Yes! 👏 You were referred by <strong>&ldquo;{this.props.referrallink}&rdquo;</strong> so you&rsquo;ll both get an extra free month!</p>
                  <p>&nbsp;</p>
                </div>
              : null }
              
              
              <div className="clearflex">
                <div className="half column">
                  <p><img src={signupMobile} alt="Really Simple Store on mobile screens" /></p>
                </div>
                <div className="half column">
                  <h2>Create your free, personal account.</h2>
                  <p>You can manage one or many stores from your personal account.</p>

                  <p className="error">{this.state.error ? "🚨 "+this.state.error : ""}</p>
                  <Input ref="nameinput" label='Name (Optional)' type='text' name='name' value={this.state.form.name} onChange={this._updateSingle} noSave={true} onKeyDown={this._keyboardListen_enter} />
                  <Input ref="emailinput" label='Email' type='email' name='email' value={this.state.form.email} onChange={this._updateSingle} noSave={true} onKeyDown={this._keyboardListen_enter} />
                  <Input ref="passphraseinput" label='Password/Passphrase' tooltip="A passphrase is more secure and easier to remember than a password. It's just three or four words strung together... like ''correct horse battery staple''." type='text' name='password' hidable value={this.state.form.password} onChange={this._updateSingle} noSave={true} onKeyDown={this._keyboardListen_enter} />
                  <Button label="&nbsp;" onClick={this._addUser} text="Create a Free Account" />
                  <p>&nbsp;</p>
                  <p>Looking for the <a onClick={this._toggleSignInUp}>sign in</a>?</p>
                </div>
              </div>

            </div>
          : // Sign In //
            <div>
              <p className="error">{this.state.error || "Welcome back. You're not signed in."}</p>
              <Input ref="emailinput" label='Email' type='email' name='email' value={this.state.form.email} onChange={this._updateSingle} noSave={true} onKeyDown={this._keyboardListen_enter} />
              {this.state.signInWithPassword ?
                <div>
                  <Input ref="passphraseinput" label='Password/Passphrase' tooltip="A passphrase is more secure and typically easier to remember than a password. It's three or four words strung together... like ''correct horse battery staple''." type='text' name='password' hidable value={this.state.form.password} onChange={this._updateSingle} noSave={true} onKeyDown={this._keyboardListen_enter} />
                  <Button label="&nbsp;" onClick={this._signIn} text="Sign In" />
                  <p><a onClick={this._toggleSignInWithPassword} style={{fontWeight:"400",fontStyle:"italic",borderBottom:"1px dotted"}}>Or sign in with your email only</a></p>
                </div>
              :
                <div>
                  <p><a onClick={this._toggleSignInWithPassword} style={{fontWeight:"400",fontStyle:"italic",borderBottom:"1px dotted"}}>Sign in with your password</a></p>
                  <Button label="&nbsp;" onClick={this._forgotPassword} text="Send a sign in link" />
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                </div>
              }

              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>Forget your password? <a onClick={this.state.signInWithPassword ? this._toggleSignInWithPassword : this._forgotPassword}>Get a one-click sign in link.</a></p>
              <p>Need to <a onClick={this._toggleSignInUp}>create an account</a>? 👀</p>
            </div>
          }

          <div className="footer" style={{padding:"2em",textAlign:"center",marginTop:"8em",borderTop:"1px solid rgba(0,0,0,.15)"}}>
            <p><strong>Really Simple Store</strong></p>
            <p><a href="mailto:drew@reallysimplestore.com">drew@reallysimplestore.com</a></p>
            <p>&nbsp;</p>
            <p>&copy; 2019 Work and Whistle, LLC | Austin, TX USA</p>
          </div>

        </div>
      );
  
  }







  _addUser() {

      var _this = this;

      var ifreferrer = "";
      if (this.props.referrallink && this.props.referrallink !== "new") { ifreferrer = "&referrer="+_this.props.referrallink; }
      // add user with generic api token
      var request = new Request(`${API_BASE}`+"users?name="+_this.state.form.name+"&email="+_this.state.form.email+"&password="+_this.state.form.password+ifreferrer, {
        method: 'POST', 
        mode: 'cors'
      });

      _this.setState({ notificationText:"Creating account...",error:"" });
      fetch(request).then(function(response) {
          return response.json();
      }).then(function(json) {
        
        if (json.error || json.password || json.email) {

          var error = "";
          if (json.error) { error = json.error; }
          if (json.password) { error = "You forgot to enter a password..."; }
          if (json.email) { error = "Accounts need a valid email address!"; }

          _this.setState({
            error:error,
            notificationText:error
          });
        } else {
          
          // sign in new user before clearing password
          _this._signIn();

          // clear form and success message
          _this.setState({
            error:"",
            form:{
              name:"",
              password:"",
              email:""
            },
            notificationText:"Account created! 👏"
          });
        }

      }).catch(function(ex) {
        console.log('parsing failed', ex);
      });



      
  }


  _forgotPassword() {

    if (this.state.form.email) {
      
      var _this = this;
      var returnparam = _this.props.params && _this.props.params.redirect ? "&return="+_this.props.params.redirect : ""; // this doesn't work yet; not sure why

      var request = new Request(`${API_BASE}auth/forgetpassword?email=`+this.state.form.email+returnparam, {
        method: 'POST', 
        mode: 'cors'
      });

      fetch(request).then(function(response) {
        
        if (response.status === 200) {
          _this.setState({
            notificationText:"A one-click sign in link was sent to your email!"
          });
        } else {
          _this.setState({
            notificationText:"Oops. We couldn't find that email..."
          });      
        }
      
      }).catch(function(ex) {
        //console.log('parsing failed', ex);

        _this.setState({
          notificationText:"Oops. Something went wrong..."
        });

      });

    } else {
      alert("Enter your email in the email field and try again...");
    }

  }

  _keyboardListen_enter(e) {
      if (e.keyCode === 13) {
          this._signIn();
      }
  }

  _signIn() {
    
    var _this = this;


    localStorage.setItem('email',this.state.form.email);
    _this.setState({
      error:"Signing in...",
      email:this.state.form.email
    });


      // get values from api/database
      var email = this.state.form.email;//document.querySelector('input[name=email]').value;
      var password = this.state.form.password; //document.querySelector('input[name=password]').value;

      var request = new Request(`${API_BASE}auth/login?email=`+email+"&password="+password, {
        method: 'POST', 
        mode: 'cors'
      });

      fetch(request).then(function(response) {
        
        if (!response.ok) {
            
            if (response.status === 401) {
              _this.setState({
                error:"Try a different email or passphrase...",
                notificationText:"Couldn't sign in..."
              });
            } else {
              _this.setState({
                error:"Couldn't sign in...",
                notificationText:"Something went wrong 😓"
              });
            }
            throw Error(response.statusText);
        }

        return response.json();
      }).then(function(json) {
        //console.log(json.token);
        
        _this.setState({
          user_id:json.id,
          email:json.email
        });
        
        // store some stuff
        localStorage.setItem('user_id',json.id);
        localStorage.setItem('name',json.name);
        localStorage.setItem('email',json.email);
        localStorage.setItem('image','https://image.devidentify.com/'+json.email);
        localStorage.setItem('token',json.token);

        cookie.save("user_id",json.id,{ path : '/'});
        cookie.save("user_id",json.id,{ path : '/', domain : 'reallysimplestore.com'});
        cookie.save("user_token",json.token,{ path : '/'});
        cookie.save("user_token",json.token,{ path : '/', domain : 'reallysimplestore.com'});

        // set timezone offset
        var offset = new Date().getTimezoneOffset();
        localStorage.setItem("timezone_offset",offset);
        
        // update main app with sign in
        if (_this.props.success) {
          _this.props.success();
        }
        if (_this.props.params.redirect) {
          window.location.href = "//"+_this.props.params.redirect;
        }
      
      }).catch(function(error) {
        
        //console.log('parsing failed', ex);
        //_this.setState({error:ex.Error});

      });

  }

  _toggleSignInUp() {
    this.setState({
      signup:!this.state.signup
    });
  }

  _toggleSignInWithPassword() {
    this.setState({
      signInWithPassword:!this.state.signInWithPassword
    });
  }

  _updateSingle(name,value) {
    var form = this.state.form;

    // update value
    form[name] = value;

    this.setState({
      form:form
    });
  }


}

export default Authentication;



// WEBPACK FOOTER //
// ./src/Authentication.js